import { ReduxProvider } from "components/common/ReduxProvider/ReduxProvider";
import { ImageUploader } from "components/common/Uploader/ImageUploader/ImageUploader";
import { getHtmlFileInputId, getSupportedExtensions } from "./utils";
import { useRouter } from "next/router";
import { useDailyQuota } from "@/modules/DailyQuota/hooks/useDailyQuota";
import { MAX_UPLOAD_LIMIT } from "../uploaderUtils";
import { useBulkResizeUploader } from "client/components/modules/Uploader/BulkResize/useBulkResizeUploader";

const ResizeUploaderContent = () => {
    const { deleteImage, deleteAllImages } = useBulkResizeUploader();
    const { pathname } = useRouter();
    const quotaManager = useDailyQuota();
    return (
        <ImageUploader
            deleteImage={deleteImage}
            deleteAllImages={deleteAllImages}
            maxUploads={MAX_UPLOAD_LIMIT}
            analytics={{
                pageKey: "image_resizer",
                pageTitle: "Image Resizer",
            }}
            htmlFileInputId={getHtmlFileInputId(pathname)}
            supportedExtensions={getSupportedExtensions(pathname)}
            quotaManager={quotaManager}
        />
    );
};

export const ResizeUploader = () => {
    return (
        <ReduxProvider>
            <ResizeUploaderContent />
        </ReduxProvider>
    );
};
